export class LocationService {
    _getAddressObject(value) {
        return {
            addressId : value.address_id,
            addressLine1 : value.address_line_1,
            addressLine2 : value.address_line_2,
            cityName : value.city_name,
            stateName : value.state_name,
            stateCode : value.state_code,
            lat: value.latitude,
            lng: value.longitude,
            zipcode : value.zip_code,
            status : value.status || -1
        }
    }
    
    _setAddressObject(value) {
        return {
            address_id : value.addressId,
            address_line_1 : value.addressLine1,
            address_line_2 : value.addressLine2,
            city_name : value.cityName,
            state_name : value.stateName,
            state_code : value.stateCode,
            latitude: value.lat,
            longitude: value.lng,
            zip_code : value.zipcode,
            //status : value.status
        }
    }
    
    _getContactMapping(value){
        return {
            contactId : value.contact_id,
            primaryEmail : value.primary_email || '',
            secondaryEmail : value.secondary_email || '',
            primaryPhone : value.primary_number ? parseInt(value.primary_number) : null,
            secondaryPhone : value.secondary_number ? parseInt(value.secondary_number) : null,
            workPhone : value.work_number ? parseInt(value.work_number): null,
            isWorkPrimary: value.is_work_number_primary || false,
            extn : value.extn ? parseInt(value.extn) : null,
            status : value.status || -1
        };
    }
    
    _setContactMapping(value){
        return {
            contact_id : value.contactId,
            primary_email : value.primaryEmail,
            secondary_email : value.secondaryEmail || null,
            primary_number : value.primaryPhone,
            secondary_number : value.secondaryPhone || null,
            workPhone : value.work,
            is_work_number_primary : value.isWorkPrimary,
            extn : value.extn,
            //status : value.status
        }
    };
};


// WEBPACK FOOTER //
// ./src/app/common/libs/location/location.service.js